import {
    MDBAlert,
    MDBBtn,
    MDBDatatable,
    MDBIcon,
    MDBInput
} from 'mdb-react-ui-kit';
import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from "react-i18next";
import PopupLoader from "../popups/PopupLoader";
import AddRemoveNum from '../popups/callblocking/AddRemoveNum';
import DeleteCallBlocking from '../popups/callblocking/DeleteCallBlocking';
import { formattedNumber } from '../popups/phonenumbers/AddRemoveNumbers';
import { Tooltip } from 'react-tooltip';
import PopupLoaderNew from '../popups/PopupLoaderNew';
import { customSearch, useAutoFocusSearchAfterLoads } from '../../components/CustomSearchUtil/CustomSearch';
import UIConstant from '../../apiclients/UIConstant';

function CallBlockingBlackList(props) {
    const [selectedRegion, setSelectedRegion] = useState("IN");
    const { t, i18n } = useTranslation();
    const [AddNubers2, setAddNubers2] = useState(false);
    const toggleOpen3 = () => setAddNubers2(!AddNubers2);

    const [DeleteNuber2, setDeleteNuber2] = useState(false);
    const toggleOpen4 = () => setDeleteNuber2(!DeleteNuber2);
    const [blackList, setBlackList] = useState([]);
    const [blackListObj, setBlackListObj] = useState({});
    const [addEditBlackFlag, setAddEditBlackFlag] = useState(false);
    const [modifiedBlackObj, setModifiedBlackObj] = useState({});
    const [successMessage, setSuccessMessage] = useState("");
    const [message, setMessage] = useState(false);
    const [isEditB, setIsEditB] = useState(false);
    const [bUniqueId, setBUniqueId] = useState(0);
    const [deleteBRowFlag, setDeleteBRowFlag] = useState(false);
    const addBlackListRef = useRef(null);
    const [isLoading, setisLoading] = useState(false);
    const [searchValue, setSearchValue] = useState("");
    const [filteredRows, setFilteredRows] = useState([]);
    const [blackListDetails, setBlackListDetails] = useState([]);
    const [dataLoaded, setDataLoaded] = useState(false);
    const searchRef = useRef(null);

    function handleClick() {
        addBlackListRef.current.click();
    }
useAutoFocusSearchAfterLoads(dataLoaded,setDataLoaded,searchRef,props.isActive)
    useEffect(() => {
        if (props?.blockList && props?.blockList?.black_list && props?.blockList?.black_list?.length > 0) {
            const tempList = props?.blockList?.black_list.map((num) => ({
                ...num,
                ph_number: formattedNumber(num.ph_number),
                phonenumber: num.ph_number,
            }));
            setBlackList(tempList);


        } else {
            setBlackList([]);
        }

    }, [props.blockList]);

    useEffect(() => {
        if (successMessage) {
            setMessage(true);
            setTimeout(() => {
                setMessage(false);
                setSuccessMessage(""); // Clear the success message in the parent component
            }, 5000);
        }
    }, [successMessage]);

    useEffect(() => {
        if (deleteBRowFlag) {
            const updateList = blackList.filter((item) => item.unique_id != bUniqueId);
            setBlackList(updateList);
            setDeleteBRowFlag(false);
        }
    }, [deleteBRowFlag]);

    useEffect(() => {
        if (Object.keys(modifiedBlackObj).length > 0 && addEditBlackFlag) {
            if (modifiedBlackObj.isEdited) {
                sendEditApiRequest(modifiedBlackObj);
            } else {
                sendAddApiRequest(modifiedBlackObj);
            }
            setAddEditBlackFlag(false);
        }

    }, [modifiedBlackObj, addEditBlackFlag]);

    async function sendAddApiRequest(modifiedObj) {
        try {
            setBlackList([...blackList, modifiedObj]);
        } catch (error) {

        }

    }

    function handleAdd() {
        setBlackListObj({
        })
        setIsEditB(false);
        toggleOpen3();
    }
    const handleBEdit = (whiteObj) => {
        setBlackListObj({
            id: whiteObj.unique_id,
            ph_number: whiteObj.ph_number,
            comment: whiteObj.comment
        })
        setIsEditB(true);
        toggleOpen3();
    }

    async function sendEditApiRequest(modifiedObj) {
        try {
            delete modifiedObj.isEdited;
            // Filter out the existing object from blackList and add the updated existObj
             setBlackList(prev => {
                const newList = [...prev]; // create new array reference
                const index = newList.findIndex(item => item.unique_id === modifiedObj.unique_id);

                if (index !== -1) {
                    newList[index] = { ...modifiedObj }; // replace with new object reference
                }

                return newList; // return new array → triggers re-render & useEffect
            });


        } catch (error) {

        }
    }

    const handleBDelete = (uniqueid) => {
        setBUniqueId(uniqueid);
        toggleOpen4();
    }
useEffect(()=>{
    let proccessdRows = [];
    blackList.map((number) => {
        let phNumber = number.ph_number ? formattedNumber(number.ph_number) + "" : ""
        proccessdRows.push({
            unique_id: number.unique_id ?? "",
            ph_number: number.ph_number ?? "",
            phonenumber: number.phonenumber ?? "",
            actualNumber: phNumber?.toString()?.replace(/[ ]/g, '') ?? "",
            created_date: number.created_date ?? "",
            // created_date_Ac: number.created_date?.toString()?.replace(/[-:\s]/g, "") ?? "",
            comment: number.comment ?? "",

            action: (
                <>
                    {/* <MDBIcon fas icon="edit" color='primary' onClick={(e) => handleBEdit(number)} /> */}
                    {/* <MDBIcon fas icon="times" color='primary' title="Remove" className='ms-3 cursor-pointer' onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        handleBDelete(number.unique_id);
                    }
                    } /> */}

                    <div className="d-flex align-items-center justify-content-center">
                        <div className="custom-hover-bg p-1 cursor-pointer deleteToolTip" onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            handleBDelete(number.unique_id);
                        }}>
                            <MDBIcon fas icon="times" color="primary" className="mx-2 fs-5" />
                        </div>
                    </div>
                </>
            )
        });
    });
    setFilteredRows(proccessdRows);
    setBlackListDetails(proccessdRows)
    setDataLoaded(true)
    },[blackList])
    const actionData2 = {
        columns: [
            { label: 'Numbers', field: 'ph_number', sort: true },
            { label: 'Comments', field: 'comment' },
            { label: 'Added On', field: 'created_date' },
            { label: 'Remove', field: 'action', sort: false },
        ],
        rows: blackListDetails,
    };
   
    const handleManualSearch = (searchValue) => {
        setSearchValue(searchValue);
        const filtered = customSearch(blackListDetails, searchValue, UIConstant.CALL_BLOCKING_BLACK_LIST);

        setFilteredRows(filtered);
    };

    return (
        <>
            <div>
                <div className="d-flex justify-content-between actionbar">
                    <div className="input-group w-25"></div>
                    <div>
                        <MDBBtn onClick={handleAdd}><MDBIcon fas icon="plus" className="me-2" />{t("add_Numbers")}</MDBBtn>
                    </div>
                </div>
                <div className='mb-2 mt-0 position-relative w-auto'>
                    <MDBInput
                        label="Search"
                        ref={searchRef}
                        value={searchValue}
                        onChange={(e) => handleManualSearch(e.target.value)}
                    />
                    <MDBIcon fas icon="search" className='MDBDatatable-Search' />
                </div>
                <div className="whitelistDatatable">
                    <MDBDatatable
                        key={searchValue}
                        // search 
                        entries={50} data={{ ...actionData2, rows: filteredRows }}
                        fixedHeader
                        onRowClick={(event) => {
                            handleBEdit(event)
                        }}
                        sortField="Numbers" className='actioncolumn'
                    />

                </div>
            </div>


            {AddNubers2 && (
                <PopupLoaderNew
                    // className="modal-lg"
                    title={isEditB ? t('editclacklistNumbers') : t('addclacklistNumbers')}
                    content={
                        <AddRemoveNum
                            ListObj={blackListObj}
                            modifyFlag={setAddEditBlackFlag}
                            modifiedObj={setModifiedBlackObj}
                            setSuccessMessage={setSuccessMessage}
                            fieldname="blacklist_phnum"
                            editEnable={isEditB}
                            onClose={toggleOpen3}
                            ref={addBlackListRef}
                            setIsloading={setisLoading}
                        />
                    }
                    onShow={setAddNubers2}
                    onClose={toggleOpen3}
                    onSave={handleClick}
                    isloading={isLoading}
                    flag={isEditB ? 2 : 1}
                />
            )}

            {DeleteNuber2 && (
                <PopupLoaderNew
                    title={t('removenumbers')}
                    content={<DeleteCallBlocking
                        rowUniq={bUniqueId}
                        onClose={toggleOpen4}
                        isWhiteList={false}
                        deleteRowFlag={setDeleteBRowFlag}
                        setSuccessMessage={setSuccessMessage}
                        ref={addBlackListRef}
                        setIsloading={setisLoading}
                    />}
                    onShow={setDeleteNuber2}
                    onClose={toggleOpen4}
                    onSave={handleClick}
                    isloading={isLoading}
                    flag={4}
                />
            )}

            {successMessage && (
                <MDBAlert
                    open
                    className="alert-center"
                    color="success"
                    autohide
                    position="bottom-right"
                    delay={10000}
                >
                    <i className="fas fa-check-circle me-3"></i>
                    <span className="alert-msg">{successMessage}</span>
                </MDBAlert>
            )}
            <Tooltip anchorSelect=".deleteToolTip" place="top" className="exampleTooltip">
                Remove
            </Tooltip>
        </>
    )
}

export default CallBlockingBlackList;
